import { importAll } from 'core/utils/import';

export const tapSounds = importAll(
  require.context('../../../public/audio/tap')
);
export const doorCreeks = importAll(
  require.context('../../../public/audio/door_creek')
);
export const doorCloses = importAll(
  require.context('../../../public/audio/door_close')
);
export const doorOpens = importAll(
  require.context('../../../public/audio/door_open')
);
export const churchBells = importAll(
  require.context('../../../public/audio/church_bell')
);
export const playerEnters = importAll(
  require.context('../../../public/audio/player_enter')
);
export const playerResurrections = importAll(
  require.context('../../../public/audio/player_resurrection')
);
export const humanDeath = importAll(
  require.context('../../../public/audio/human_death')
);
